import store from '../store/index'
//---------------------
// get adj payload ids
//---------------------
export default function getAdjPayloadIds({ payload, category, name, character }) {
  console.log('--------------------------')
  console.log('IN getAdjPayloadIds= ', { category, name })

  //==========================================================
  // A. where category = ability (CharacterAbilityAdjustment)
  //----------------------------------------------------------
  if (category === 'ability') {
    console.log('getting character id for ability adj = ', character.id)
    //---------------------------------------------------------------------------------
    // get character id from character object (id may be null/0 where new character).
    // in this case the updates harness will insert the returned id post character add
    // --------------------------------------------------------------------------------
    if (character && character.id && character.id !== 0) {
      payload.character = character.id
    } else {
      payload.character = null
    }
    //---------------------------
    // get static ability object
    //---------------------------
    let ability = store.getters['characters/getAbility'](name)
    if (!ability) {
      payload.ability = null
    } else {
      payload.ability = ability.id
      console.log('getting ability id for ability adj = ', ability.id)
    }

    //========================================================================
    // B. where category = characteristic (CharacterCharacteristicAdjustment)
    //------------------------------------------------------------------------
  } else if (category === 'characteristic' || category === 'characteristic-skill') {
    //------------------------
    // where character exists
    //------------------------
    if (character && character.characteristics) {
      //-------------------------------------------------------
      // get character-characteristic id from character object
      //-------------------------------------------------------
      const idx = character.characteristics.findIndex((c) => c.name === name)
      if (idx !== -1) {
        console.log(
          'getting characteristic id for characteristic adj = ',
          character.characteristics[idx].id,
        )
        payload.character_characteristic = character.characteristics[idx].id
      } else {
        alert('ERROR: cannot find characteristic for new adj = ' + name)
      }
      //--------------------------------------------------------
      // new character (value populated during updates harness)
      //--------------------------------------------------------
    } else {
      payload.character_characteristic = null
    }
    //======================================================
    // C. where category = skill (CharacterSkillAdjustment)
    //------------------------------------------------------
  } else if (category === 'skill') {
    //------------------------
    // where character exists
    //------------------------
    if (character.id !== 0 && character.skills) {
      //----------------------------------------------
      // get character-skill id from character object
      //----------------------------------------------
      const idx = character.skills.findIndex((c) => c.name === name || c.display_name === name)
      if (idx !== -1) {
        payload.character_skill = character.skills[idx].id
      } else {
        console.error('ERROR: cannot find skill for new adj = ' + name)
      }
      //--------------------------------------------------------
      // new character (value populated during updates harness)
      //--------------------------------------------------------
    } else {
      payload.character_skill = null
    }
    //========
    // ERRORS
    //--------
  } else {
    console.error('ERROR: unknown category in getAdjSubjectId = ' + category)
  }
  return payload
}
